import * as React from 'react'

interface IconProps {
	size?: number
	color?: string
	className?: string
}

export const BrushIcon = ({ size = 24, color = 'currentColor', className }: IconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		className={className}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M9.06 11.9l8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08" />
		<path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2.5 1.52 0 1.61 1.21 2.94 2.66 3.22 1.66.32 3.4-.19 4.6-1.48 1.2-1.29 1.6-3.09 1.23-4.77-.31-1.44-1.63-2.69-3.23-2.7z" />
	</svg>
)
